import { LayoutAnimationEasing } from './types';
import { Easing } from '../../TweenManager/easing';

export const layoutEasingToGameEasingMap: Record<LayoutAnimationEasing, (k: number) => number> = {
  [LayoutAnimationEasing.Linear]: Easing.Linear.None,
  [LayoutAnimationEasing.QuadraticInOut]: Easing.Quadratic.InOut,
  [LayoutAnimationEasing.QuadraticIn]: Easing.Quadratic.In,
  [LayoutAnimationEasing.QuadraticOut]: Easing.Quadratic.Out,
  [LayoutAnimationEasing.CubicInOut]: Easing.Cubic.InOut,
  [LayoutAnimationEasing.CubicIn]: Easing.Cubic.In,
  [LayoutAnimationEasing.CubicOut]: Easing.Cubic.Out,
  [LayoutAnimationEasing.QuarticInOut]: Easing.Quartic.InOut,
  [LayoutAnimationEasing.QuarticIn]: Easing.Quartic.In,
  [LayoutAnimationEasing.QuarticOut]: Easing.Quartic.Out,
  [LayoutAnimationEasing.QuinticInOut]: Easing.Quintic.InOut,
  [LayoutAnimationEasing.QuinticIn]: Easing.Quintic.In,
  [LayoutAnimationEasing.QuinticOut]: Easing.Quintic.Out,
  [LayoutAnimationEasing.SinusoidalInOut]: Easing.Sinusoidal.InOut,
  [LayoutAnimationEasing.SinusoidalIn]: Easing.Sinusoidal.In,
  [LayoutAnimationEasing.SinusoidalOut]: Easing.Sinusoidal.Out,
  [LayoutAnimationEasing.ExponentialInOut]: Easing.Exponential.InOut,
  [LayoutAnimationEasing.ExponentialIn]: Easing.Exponential.In,
  [LayoutAnimationEasing.ExponentialOut]: Easing.Exponential.Out,
  [LayoutAnimationEasing.CircularInOut]: Easing.Circular.InOut,
  [LayoutAnimationEasing.CircularIn]: Easing.Circular.In,
  [LayoutAnimationEasing.CircularOut]: Easing.Circular.Out,
  [LayoutAnimationEasing.ElasticInOut]: Easing.Elastic.InOut,
  [LayoutAnimationEasing.ElasticIn]: Easing.Elastic.In,
  [LayoutAnimationEasing.ElasticOut]: Easing.Elastic.Out,
  [LayoutAnimationEasing.BackInOut]: Easing.Back.InOut,
  [LayoutAnimationEasing.BackIn]: Easing.Back.In,
  [LayoutAnimationEasing.BackOut]: Easing.Back.Out,
  [LayoutAnimationEasing.BounceInOut]: Easing.Bounce.InOut,
  [LayoutAnimationEasing.BounceIn]: Easing.Bounce.In,
  [LayoutAnimationEasing.BounceOut]: Easing.Bounce.Out,
};
